__webpack_require__.p = "/simbologia/";